import { ResourceAnimationSprite } from './ResourceAnimationSprite';
import { getRandomElement } from '../../../utils/array-utils';
import MathUtils from '../../../utils/MathUtils';
import { GAME_OBJECT_POOL } from '../../../game/GameConstants';
import type { ResourceAnimationConfig } from './types';

export function getResourceAnimationSprite(): ResourceAnimationSprite {
  return GAME_OBJECT_POOL.getObject(ResourceAnimationSprite) ?? new ResourceAnimationSprite();
}

export function createResourceAnimationSprites({
  parent,
  particleLayer,
  emitterConfig,
  spriteCount,
  spriteFrames,
  from,
  to,
  minDuration,
  maxDuration,
  delayIncrement = 0,
  ease,
  minScale,
  maxScale,
  onComplete,
}: ResourceAnimationConfig): ResourceAnimationSprite[] {
  const sprites: ResourceAnimationSprite[] = [];
  let completed = 0;

  for (let i = 0; i < spriteCount; i += 1) {
    const spriteFrame = getRandomElement(spriteFrames);
    const sprite = getResourceAnimationSprite().init(
      spriteFrame,
      from,
      to,
      MathUtils.getRandomValueInRange(minDuration, maxDuration),
      i * delayIncrement,
      ease,
      MathUtils.getRandomValueInRange(minScale, maxScale),
      // eslint-disable-next-line @typescript-eslint/no-loop-func
      () => {
        completed += 1;
        GAME_OBJECT_POOL.addObject(ResourceAnimationSprite, sprite);
        if (completed === spriteCount) onComplete?.();

        if (emitterConfig) {
          particleLayer.addParticleEmitter(sprite.x, sprite.y, emitterConfig);
        }
      },
    );
    parent.addChild(sprite);
    sprites.push(sprite);
  }
  return sprites;
}
